module.exports = __webpack_public_path__ + "static/media/android_rockchip_1.9620a2df.png";